<template>
  <div class="home">
    <div class="justify-between items-center hidden md:flex">
      <h1 class="text-xl md:text-3xl flex-grow flex-1">
        <LocalizeWord :value="title"></LocalizeWord>
      </h1>

      <ConfidentialPeopleSearch class="flex-grow flex-1"></ConfidentialPeopleSearch>

      <div v-if="!groupId" class="hidden xl:block flex-grow flex-1 text-right">{{ todayLong }}</div>
      <div v-if="!groupId" class="hidden md:block xl:hidden flex-grow flex-1 text-right">{{ todayShort }}</div>
    </div>

    <div class="lg:mt-12">
      <TilesGrid
        v-if="tiles.length > 0"
        :key="tiles.length"
        :tiles="tiles"
        :type-name="collectionId"
        :headline="''"
        :sort="catalog.groups.length > 0"
      />
    </div>
  </div>
</template>

<script>
import { useTilesStore } from "@/stores/tiles";
import { useSettingsStore } from "@/stores/settings";

import { StringHelper } from "@/helpers/utilities/StringHelper";
import TilesGrid from "@/components/Tiles/TilesGrid";
import LocalizeWord from "@/components/Shared/LocalizeWord";
import ConfidentialPeopleSearch from "@/components/People/ConfidentialPeopleSearch.vue";

export default {
  name: "HomeView",
  data: function () {
    return {
      selectTiles: false,
      createParam: { institution: "Institution", typeName: null, access: "Self" },
      showCreateModal: false,
      roles: [],
      catalog: {
        groups: []
      },
      createTile: {
        url: "",
        name: "",
        category: "",
        icon: "",
        role: ""
      }
    };
  },

  props: {
    groupId: { type: String, default: null }
  },

  setup() {
    return {
      settingsStore: useSettingsStore(),
      tilesStore: useTilesStore()
    };
  },

  mounted: function () {
    this.loadTiles(this.collectionId);
  },

  watch: {
    "$route.params"() {
      this.loadTiles(this.collectionId);
    }
  },

  computed: {
    tiles() {
      return this.tilesStore.tiles(this.collectionId);
    },

    collectionId() {
      return this.groupId || "UserMainTiles";
    },

    todayLong() {
      return StringHelper.capitalize(
        new Date().toLocaleDateString(
          this.settingsStore.browserLocale,
          this.settingsStore.localeFormats.veryLongDateFormOptions
        )
      );
    },

    todayShort() {
      return StringHelper.capitalize(
        new Date().toLocaleDateString(
          this.settingsStore.browserLocale,
          this.settingsStore.localeFormats.longDateFormOptions
        )
      );
    },

    title() {
      return this.tilesStore.groupTitle(this.collectionId);
    }
  },

  methods: {
    async loadTiles(id) {
      await this.tilesStore.loadTiles(id);
    }
  },

  components: {
    TilesGrid,
    LocalizeWord,
    ConfidentialPeopleSearch
  }
};
</script>
